export async function all() {
  const response = await this.get('/external_apps');

  return response;
}
